import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TableCell from 'components/TableCell';
import FlightShortDetails from 'components/FlightShortDetails';
import Dialog from 'components/Dialog';
import PackageDateAddFlightDialog from 'components/PackageDateAddFlightDialog';

import { PackageDateRowFlightDetails_packageDate$key } from '__generated__/PackageDateRowFlightDetails_packageDate.graphql';
import { PackageDateRowFlightDetails_package$key } from '__generated__/PackageDateRowFlightDetails_package.graphql';
import { PackageDateRowFlightDetails_data$key } from '__generated__/PackageDateRowFlightDetails_data.graphql';

type Props = {
  packageDate: PackageDateRowFlightDetails_packageDate$key;
  package: PackageDateRowFlightDetails_package$key;
  data: PackageDateRowFlightDetails_data$key;
};

const PackageDateRowFlightDetails: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageDateRowFlightDetails_packageDate on PackageDate {
        flight {
          id
          priceLive

          lastUpdate {
            status
          }

          ...FlightShortDetails_flight
        }

        ...PackageDateAddFlightDialog_packageDate
      }
    `,
    props.packageDate
  );

  const pack = useFragment(
    graphql`
      fragment PackageDateRowFlightDetails_package on Package {
        transportType

        ...PackageDateAddFlightDialog_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageDateRowFlightDetails_data on Query {
        ...PackageDateAddFlightDialog_data
      }
    `,
    props.data
  );

  const { flight } = packageDate;

  return (
    <TableCell center>
      {flight ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <FlightShortDetails
            showTime={false}
            flight={flight}
            linkTo={`/flights/${flight.id}#price-history`}
          />
        </Box>
      ) : (
        <Dialog
          fullWidth
          maxWidth="md"
          activateButton={open => (
            <IconButton color="inherit" size="small" onClick={open}>
              <AddIcon />
            </IconButton>
          )}>
          <PackageDateAddFlightDialog
            packageDate={packageDate}
            data={data}
            package={pack}
          />
        </Dialog>
      )}
    </TableCell>
  );
};

export default PackageDateRowFlightDetails;
